import { useTranslation } from 'react-i18next';

import { Lock } from '@unified-checkout/design-system/icons/index';

import { TimelineBox } from '@app/dashboard/components/inner_layout/Cards/TimelineBox';

const Timeline = () => {
  const { t } = useTranslation();

  return (
    <TimelineBox
      title={t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.timeline.title')}
      steps={[
        {
          title: {
            value: 'Payment succeeded',
          },
          date: '24 Nov 2024, 1:06 AM',
          status: 'success',
        },
        {
          title: {
            value: 'Failed payment with Visa **** 2341',
            emphasizedValue: 'Visa **** 2341',
          },
          description:
            'This charge request was in live mode, but used a Stripe test card number.',
          date: '24 Nov 2024, 1:06 AM',
          status: 'default',
          icon: Lock,
        },
        {
          title: {
            value: 'The cardholder attempted 3D Secure authentication 4 times.',
          },
          date: '24 Nov 2024, 1:06 AM',
          status: 'failed',
        },
        {
          title: {
            value: 'Payment created',
          },
          date: '24 Nov 2024, 1:06 AM',
          status: 'default',
          icon: Lock,
        },
      ]}
    />
  );
};

export default Timeline;
